import React from 'react'
import { Portal } from 'react-portal'
import { useConnect } from 'sb-redux-hook'
import { useState, useEffect, useTimer } from 'sb-hooks'

import DoNotClosePageBanner from 'components/payment/DoNotClosePageBanner/DoNotClosePageBanner'


const delayDisplayingProcessBanner = 20000

const PaymentProcessBanner = () => {
  const { isSubscriptionFetching, isInstantShowDisplayProcessBanner } = useConnect({
    isInstantShowDisplayProcessBanner: 'models.payment.instantShowDisplayProcessBanner',
    isSubscriptionFetching: 'models.payment.isSubscriptionFetching',
  })

  const [ isVisible, setVisible ] = useState(false)

  const { setTimer, clearTimer, timer } = useTimer({
    delay: delayDisplayingProcessBanner,
    callback: () => setVisible(true),
  })

  useEffect(() => {
    if (isInstantShowDisplayProcessBanner) {
      setVisible(isSubscriptionFetching)

      return
    }

    if (!timer && isSubscriptionFetching) {
      setTimer()
    }

    if (!isSubscriptionFetching) {
      clearTimer()
      setVisible(false)
    }
  }, [ isInstantShowDisplayProcessBanner, isSubscriptionFetching, setTimer, timer ])

  return isVisible ? (
    <Portal>
      <DoNotClosePageBanner />
    </Portal>
  ) : null
}


export default PaymentProcessBanner
